// extracted by mini-css-extract-plugin
export default {"wrapper":"jr-z","response":"kr-z","error":"lr-z","disabled":"mr-z","buttons":"nr-z","feedbackQuestionSection":"or-z","yesNoWrapper":"pr-z"};